import { render, staticRenderFns } from "./reportConfirmOrder.vue?vue&type=template&id=6a5bb13d&scoped=true"
import script from "./reportConfirmOrder.vue?vue&type=script&lang=js"
export * from "./reportConfirmOrder.vue?vue&type=script&lang=js"
import style0 from "./reportConfirmOrder.vue?vue&type=style&index=0&id=6a5bb13d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5bb13d",
  null
  
)

export default component.exports